module.exports = __webpack_public_path__ + "media/edsheeran.fca7c86a.mp3";